import {ErrorPage} from '@src/Layers/ErrorLayer/ErrorPage.tsx'
import {MainLayout} from './MainLayout.tsx'
import {AppRouteObject} from './types.ts'
import {checkInRoute} from "../../Pages/ChekInRouter.tsx";
import {settingsPageRoute} from "@src/Pages/SettingsPageRouter.tsx";
import {attendanceHistoryPageRoute} from "@src/Pages/AttendanceHistoryRouter.tsx";
import {route as requestsRouter} from "@src/Pages/RequestsPage/router.tsx";
import {calendarPageRoute} from "@src/Pages/Calendar/router.tsx";

export const mainRoute: AppRouteObject = {
    element: <MainLayout/>,
    errorElement: <ErrorPage/>,
    children: [checkInRoute, settingsPageRoute, attendanceHistoryPageRoute, requestsRouter, calendarPageRoute]
}
